import React from "react";
import { useFormContext } from "react-hook-form";
import Input from "Components/UI/Input";

const isStatusOption = [
  { id: 1, label: "Active", value: true },
  { id: 0, label: "Inactive", value: false },
];

const VehicleExpensesForm = () => {
  const {
    watch,
    setValue,
    trigger,
    register,
    formState: { errors },
  } = useFormContext();

  console.log(watch());

  return (
    <div className="form-row row">
      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="vehicleNumber"
          type="text"
          placeholder="Vehicle Number"
          className={`form-control ${errors.vehicleNumber ? "is-invalid" : ""}`}
          label="Vehicle Number"
          labelClassName="form-label"
          required={true}
          requiredMessage="Vehicle Number is required"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="insuranceNumber"
          type="text"
          placeholder="Insurance Number"
          className={`form-control ${
            errors.insuranceNumber ? "is-invalid" : ""
          }`}
          label="Insurance Number"
          labelClassName="form-label"
          required={true}
          requiredMessage="Insurance Number is required"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="insurancePeriod"
          type="text"
          placeholder="Insurance Period"
          className={`form-control ${
            errors.insurancePeriod ? "is-invalid" : ""
          }`}
          label="Insurance Period"
          labelClassName="form-label"
          required={true}
          requiredMessage="Insurance Period is required"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="company"
          type="text"
          placeholder="Company"
          className={`form-control ${errors.company ? "is-invalid" : ""}`}
          label="Company"
          labelClassName="form-label"
          required={true}
          requiredMessage="Company is required"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="insuranceAmount"
          type="number"
          placeholder="Insurance Amount"
          className={`form-control ${
            errors.insuranceAmount ? "is-invalid" : ""
          }`}
          label="Insurance Amount"
          labelClassName="form-label"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="insuranceVendor"
          type="text"
          placeholder="Insurance Vendor"
          className={`form-control ${
            errors.insuranceVendor ? "is-invalid" : ""
          }`}
          label="Insurance Vendor"
          labelClassName="form-label"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="insuranceAgency"
          type="text"
          placeholder="Insurance Agency"
          className={`form-control ${
            errors.insuranceAgency ? "is-invalid" : ""
          }`}
          label="Insurance Agency"
          labelClassName="form-label"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="insuranceExpiryDate"
          type="date"
          placeholder="Insurance Expiry Date"
          className={`form-control ${
            errors.insuranceExpiryDate ? "is-invalid" : ""
          }`}
          label="Insurance Expiry Date"
          labelClassName="form-label"
          required={true}
          requiredMessage="Insurance Expiry Date is required"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="craneInsuranceExpiryDate"
          type="date"
          placeholder="Crane Insurance Expiry Date"
          className={`form-control ${
            errors.craneInsuranceExpiryDate ? "is-invalid" : ""
          }`}
          label="Crane Insurance Expiry Date"
          labelClassName="form-label"
          required={true}
          requiredMessage="Crane Insurance Expiry Date is required"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="lorryCraneLMCertExpiryDate"
          type="date"
          placeholder="Lorry Crane LM Cert Expiry Date"
          className={`form-control ${
            errors.lorryCraneLMCertExpiryDate ? "is-invalid" : ""
          }`}
          label="Lorry Crane LM Cert Expiry Date"
          labelClassName="form-label"
          required={true}
          requiredMessage="Lorry Crane LM Cert Expiry Date is required"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="lgNextDueDate"
          type="date"
          placeholder="LG Next Due Date"
          className={`form-control ${errors.lgNextDueDate ? "is-invalid" : ""}`}
          label="LG Next Due Date"
          labelClassName="form-label"
          required={true}
          requiredMessage="LG Next Due Date is required"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="roadTaxDueDate"
          type="date"
          placeholder="Road Tax Due Date"
          className={`form-control ${
            errors.roadTaxDueDate ? "is-invalid" : ""
          }`}
          label="Road Tax Due Date"
          labelClassName="form-label"
          required={true}
          requiredMessage="Road Tax Due Date is required"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="inspectionDueDate"
          type="date"
          placeholder="Inspection Due Date"
          className={`form-control ${
            errors.inspectionDueDate ? "is-invalid" : ""
          }`}
          label="Inspection Due Date"
          labelClassName="form-label"
          required={true}
          requiredMessage="Inspection Due Date is required"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="roadTaxInspectionAmount"
          type="number"
          placeholder="Road Tax Inspection Amount"
          className={`form-control ${
            errors.roadTaxInspectionAmount ? "is-invalid" : ""
          }`}
          label="Road Tax Inspection Amount"
          labelClassName="form-label"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="roadTaxInvRef"
          type="text"
          placeholder="Road Tax Invoice Reference"
          className={`form-control ${errors.roadTaxInvRef ? "is-invalid" : ""}`}
          label="Road Tax Invoice Reference"
          labelClassName="form-label"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="ncd"
          type="text"
          placeholder="No Claim Discount"
          className={`form-control ${errors.ncd ? "is-invalid" : ""}`}
          label="No Claim Discount"
          labelClassName="form-label"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="remarks"
          type="text"
          placeholder="Remarks"
          className={`form-control ${errors.remarks ? "is-invalid" : ""}`}
          label="Remarks"
          labelClassName="form-label"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="parkingNextDueDate"
          type="date"
          placeholder="Next Parking Due Date"
          className={`form-control ${
            errors.parkingNextDueDate ? "is-invalid" : ""
          }`}
          label="Next Parking Due Date"
          labelClassName="form-label"
          required={true}
          requiredMessage="Next Parking Due Date is required"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="vpc"
          type="text"
          placeholder="Vehicle Parking Card"
          className={`form-control ${errors.vpc ? "is-invalid" : ""}`}
          label="Vehicle Parking Card"
          labelClassName="form-label"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="vpcAmount"
          type="number"
          placeholder="VPC Amount"
          className={`form-control ${errors.vpcAmount ? "is-invalid" : ""}`}
          label="VPC Amount"
          labelClassName="form-label"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="vpcAddress"
          type="text"
          placeholder="VPC Address"
          className={`form-control ${errors.vpcAddress ? "is-invalid" : ""}`}
          label="VPC Address"
          labelClassName="form-label"
          required={true}
          requiredMessage="VPC Address is required"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="parkingVendor"
          type="text"
          placeholder="Parking Vendor"
          className={`form-control ${errors.parkingVendor ? "is-invalid" : ""}`}
          label="Parking Vendor"
          labelClassName="form-label"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="parkingLocation"
          type="text"
          placeholder="Parking Location"
          className={`form-control ${
            errors.parkingLocation ? "is-invalid" : ""
          }`}
          label="Parking Location"
          labelClassName="form-label"
          required={true}
          requiredMessage="Parking Location is required"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="parkingAmount"
          type="number"
          placeholder="Parking Amount"
          className={`form-control ${errors.parkingAmount ? "is-invalid" : ""}`}
          label="Parking Amount"
          labelClassName="form-label"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="parkingCouponNextDueDate"
          type="date"
          placeholder="Parking Coupon Next Due Date"
          className={`form-control ${
            errors.parkingCouponNextDueDate ? "is-invalid" : ""
          }`}
          label="Parking Coupon Next Due Date"
          labelClassName="form-label"
          required={true}
          requiredMessage="Parking Coupon Next Due Date is required"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="parkingAddress"
          type="text"
          placeholder="Parking Address"
          className={`form-control ${
            errors.parkingAddress ? "is-invalid" : ""
          }`}
          label="Parking Address"
          labelClassName="form-label"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="parkingPaymentMode"
          type="text"
          placeholder="Parking Payment Mode"
          className={`form-control ${
            errors.parkingPaymentMode ? "is-invalid" : ""
          }`}
          label="Parking Payment Mode"
          labelClassName="form-label"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="fmtDueDate"
          type="date"
          placeholder="FMT Due Date"
          className={`form-control ${errors.fmtDueDate ? "is-invalid" : ""}`}
          label="FMT Due Date"
          labelClassName="form-label"
          required={true}
          requiredMessage="FMT Due Date is required"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="fmtAmount"
          type="number"
          placeholder="FMT Amount"
          className={`form-control ${errors.fmtAmount ? "is-invalid" : ""}`}
          label="FMT Amount"
          labelClassName="form-label"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="shellCardNo"
          type="text"
          placeholder="Shell Card Number"
          className={`form-control ${errors.shellCardNo ? "is-invalid" : ""}`}
          label="Shell Card Number"
          labelClassName="form-label"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="shellPIN"
          type="text"
          placeholder="Shell Card PIN"
          className={`form-control ${errors.shellPIN ? "is-invalid" : ""}`}
          label="Shell Card PIN"
          labelClassName="form-label"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="isActive"
          type="commonSelect"
          placeholder="Select Status"
          className={`form-control select ${
            errors.isActive ? "is-invalid" : ""
          }`}
          label="Status"
          labelClassName="form-label"
          optionData={isStatusOption}
          required={true}
          requiredMessage="Status is required"
          onChange={(selectedOption) => {
            setValue("isActive", selectedOption?.value);
            trigger("isActive");
          }}
          defaultValue={watch("isActive")}
        />
      </div>
    </div>
  );
};

export default VehicleExpensesForm;
